module.exports = __webpack_public_path__ + "static/media/Icon_Logo_Fator.d43fa4bf.png";